import { Dropdown } from 'primereact/dropdown';
import React, { useEffect } from 'react';

import { useGetCoreValuesQuery } from './coreValueDropdownSlice';
import { CoreValue, CoreValueDropdownProps } from './types';

export const CoreValueDropdown = (props: CoreValueDropdownProps) => {
    const coreValuesStr = window.localStorage.coreValues;
    let skip = false;
    let coreValuesJson:any;
    if (coreValuesStr) {
        try {
            coreValuesJson = JSON.parse(coreValuesStr);
            if (coreValuesJson?.length > 0) {
                skip = true;
            }
        } catch {
            delete window.localStorage.coreValues;
        }
    }
    const { data: ttecValueData } = useGetCoreValuesQuery(undefined, { skip });
    useEffect(() => {
        if (ttecValueData?.data.length > 0) {
            window.localStorage.coreValues = JSON.stringify(ttecValueData.data);
        }
    }, [ttecValueData]);
    useEffect(() => {
        const coreValues = coreValuesJson?.length > 0 ? coreValuesJson : ttecValueData?.data;
        if (coreValues?.length > 0) {
            if (props?.coreValueName && props?.coreValueName !== '') {
                const foundOption = coreValues?.find((option: any) =>
                    option.core_value_name.toLowerCase().trim() === props?.coreValueName?.toLowerCase().trim()
                );
                if (foundOption && foundOption?.core_value_id)
                    props.setCoreValue(foundOption?.core_value_id);
            }
        }
    }, [ttecValueData, coreValuesJson, props?.coreValueName]);
    const options: CoreValue[] = coreValuesJson || ttecValueData?.data || [];

    const customItemTemplate = (option: CoreValue) => (
        <div className="d-flex align-items-center justify-content-between gap-4">
            <span>{option.core_value_name}</span>
            <div style={{ whiteSpace: 'pre-line', width: '250px', fontSize: '12px', wordWrap: 'break-word' }}>
                {option.core_value_description}
            </div>
        </div>
    );

    return (
        <>
            <h6 id="core-value-dropdown">TTEC Value</h6>
            <Dropdown
                id="value"
                data-testid="core-value"
                aria-labelledby="core-value-dropdown"
                value={props.coreValue}
                options={options}
                onChange={(event) => {
                    props.setCoreValue(event.target.value);
                }}
                optionValue={'core_value_id'}
                optionLabel={'core_value_name'}
                placeholder="Select Value"
                className={`custom-dropdown ${props?.fullWidth ? 'w-100' : ''}`}
                itemTemplate={customItemTemplate}
            />
        </>
    );
};
